import { Injectable } from '@angular/core';
import  {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../AppConstants';
import {AuthorizedUserDto} from '../model/AuthorizedUserDto';

@Injectable()
export class AuthorizedUserService {

public httpOptions : any;

  constructor(private _http : HttpClient,private appConstant: AppConstants) {

  }


      //<><  SelectAll

     public  selectAll():Observable<any>{

          return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/findAll");
     }

      //<><  Add
        public  add( authorizedUserDto:AuthorizedUserDto) {

          return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/add", authorizedUserDto);
     }
      //<><  Edit
      public  edit(id :string) {

       return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/edit"+ "/"+id ,"");
      }
      //<><  Delete
      //<><  myProfile
     public myProfile(){

           return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/myProfile");
     }
      //<><  Logout
     public logout(){

           return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/logout");
     }
      //<><  RegistrationAndSendConfirmation
     public  registrationAndSendConfirmation(encrypteddata: any  ){
let formdata = new FormData();

formdata.append("encrypteddata", encrypteddata);



             return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/registrationAndSendConfirmation",formdata);
     }
      //<><  CreateUser
     public  createUser(encrypteddata: any  ){
let formdata = new FormData();

formdata.append("encrypteddata", encrypteddata);



             return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/createUser",formdata);
     }
      //<><  SendEmailWithTenant
  public  sendEmailWithTenant(){
                   return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/sendEmailWithTenant");
           }

      //<><  UserUpdate
     public  userUpdate( authorizedUserDto:AuthorizedUserDto ){


            return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/userUpdate", authorizedUserDto);
     }
      //<><  getAllAuthorizedUser
     public getAll(){
        return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/get/getAllAuthorizedUser");
     }
     public findByParentId(id:string){
           return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/get/findByParentId/"+id,"");
    }
      //<><  TenantUserRegistration
     public  tenantUserRegistration(encrypteddata: any  ){
let formdata = new FormData();

formdata.append("encrypteddata", encrypteddata);



             return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/tenantUserRegistration",formdata);
     }
      //<><  Users
     public users(){

           return this._http.get(this.appConstant.baseAppUrl+"/api/authorizedUser/users");
     }
       findOne(id: number){

              return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/findOne/"+id,"");
        }

        delete(id: number){

                    return this._http.post(this.appConstant.baseAppUrl+"/api/authorizedUser/delete/"+id,"");
          }


                  uploadProfile(file:any){
                    const formdata: FormData = new FormData();
                    let apiUrl = this.appConstant.baseAppUrl+"/api/uploadProfilePicture";
                           formdata.append('profilePicture',file);
                        return this._http.post(apiUrl, formdata);
                     }

                 public getQrcode(isAuth:boolean){
                      return this._http.get(this.appConstant.baseAppUrl+"/api/getAuthQRCode"+"/"+isAuth);
                    }

}